package org.abhranilnxt.portfolio.util

object Constants {
    const val SECTION_WIDTH = 1920
    const val FONT_FAMILY = "Roboto,sans-serif"
}

object Res {
    object Images {
        const val background = "background.svg"
        const val logo = "logo.svg"
        const val main = "self_image.png"
    }
}